import clsx from 'clsx'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import Skeleton from 'react-loading-skeleton'
import { getVariantStyles } from '../../utils'

export default function MatchScoreCard({
  className,
  variant,
  score,
  description,
  isLoading
}) {
  return (
    <div
      id='matching-profile-match-score-card'
      className={clsx('flex items-start gap-x-4', className)}
    >
      {isLoading ? (
        <Skeleton height={96} width={96} />
      ) : (
        <div
          className={clsx(
            'match-score-card flex size-24 flex-col items-center justify-center rounded border border-softGrey',
            getVariantStyles(variant)
          )}
        >
          <span className='block text-xs font-normal'>Score</span>
          <span className='mt-0.5 block text-lg font-semibold'>
            {score}/100
          </span>
        </div>
      )}
      <div className='flex-1'>
        {isLoading ? (
          <Skeleton count={3} className='w-9/12' />
        ) : (
          <ReactMarkdown className='w-9/12 text-pretty text-sm text-rockGrey'>
            {description}
          </ReactMarkdown>
        )}
      </div>
    </div>
  )
}

MatchScoreCard.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'default']),
  score: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired
}
